type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export const storage = {
  set: (key: StorageKey, value: string) => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(key, value);
    }
  },
  get: (key: StorageKey) => {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem(key);
    }
    return null;
  },
  remove: (key: StorageKey) => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem(key);
    }
  },
};

export const STORAGE_KEYS = {
  PERSONAL_DETAILS: "personalDetails",
  ORDER_TYPE: "orderType",
  ADDRESS: "address",
} as const;
